import {snapshot} from "valtio";
import store from "../../../store";

import fillStorePrice from "./fillStorePrice";
import priceCalculatorPerProduct from "./priceCalculatorPerProduct"


// --------------------------------------------------------
// Calculate price for all products
// --------------------------------------------------------
export default async function priceCalculator() {
	const snap = snapshot(store);
	const products = snap.product;
	let basePrice = await fillStorePrice(snap);//Number(store.order.basePrice);
	
	
	// Calculate price, eching count, and neatolabs cost in a single iteration
	const totals = products.reduce((acc, product) => {
		const {price, echingCount, neatolabsCost, groupCount} = priceCalculatorPerProduct(snap, product.sku);
		
		acc.totalPrice += price;
		acc.totalEchingCount += echingCount;
		acc.totalNeatolabsCost += neatolabsCost;
		acc.groupCount.push(groupCount)
		return acc;
	}, {totalPrice: basePrice, totalEchingCount: 0, totalNeatolabsCost: 0, groupCount: []});
	
	
	let totalGroupCount = Math.max(...totals.groupCount)
	const isGroupCustomization = !!snap.elements.filter(element => element[element.type]?.list?.length > 0 && element).length;
	
	
	// Update store with calculated values
	store.order.price = (totals.totalPrice * totalGroupCount).toFixed(2);

	store.order.item_price = totals.totalPrice.toFixed(2);
	store.order.eching_sections = (totals.totalEchingCount/* * totalGroupCount*/).toString();
	store.order.neatolabsCost = (totals.totalNeatolabsCost/* * totalGroupCount*/).toString();
	store.order.groupCustomization = isGroupCustomization;
	store.order.groupCustomizationCount = isGroupCustomization ? totalGroupCount : 0;
	store.order.quantity = Math.max(1, ...snap.elements.map(element => element[element.type]?.list?.length || 0)) || 1;
}